// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-a_gc","homeTitle_styleDefault":"c-a_ge","homeTitle_styleRed":"c-a_gf"};